import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { services } from '../../data/services';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
export function ServicesOverview() {
  return <section className="bg-white py-24 md:py-32" data-id="element-272" data-mp="1174ch19xvpqw">
      <div className="container-page grid gap-14 lg:grid-cols-12" data-id="element-273" data-mp="115tbf97vow3h">
        <div className="lg:col-span-4" data-id="element-274" data-mp="n7d35dudaxj8">
          <div className="lg:sticky lg:top-28" data-id="element-275" data-mp="n6bh6ebtcqmq">
            <SectionHeading kicker="Services" title="Recruitment and search, built around the role." intro="Ten specialist service lines, from board appointments to interim leadership and market intelligence." data-id="element-276" data-mp="s78xsmh6dcm4" />
            <Button to="/services" variant="outline" className="mt-8" arrow data-id="element-277" data-mp="iacx32xipus4">
              Explore all services
            </Button>
          </div>
        </div>
        <ul className="divide-y divide-line border-y border-line lg:col-span-8" data-id="element-278" data-mp="2cl9l47l3knsk">
          {services.map(s => {
          const Icon = s.icon;
          const to = s.slug === 'executive-search' ? '/executive-search' : `/services#${s.slug}`;
          return <li key={s.slug} data-id="element-279" data-mp="21lu6fs34zoev">
                <Link to={to} className="group grid grid-cols-[44px_1fr_auto] items-start gap-5 py-6 transition-colors duration-150 hover:bg-ivory/60 sm:px-3" data-id="element-280" data-mp="21kss9eqtqlsx">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-midnight text-gold-300" data-id="element-281" data-mp="18w52b5v4r891">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-282" data-mp="13ylou869azi5" />
                  </span>
                  <span data-id="element-283" data-mp="1hxlb596ar2b5">
                    <span className="block font-display text-2xl font-semibold text-ink" data-id="element-284" data-mp="1hywghdfe4i4d">{s.title}</span>
                    <span className="mt-1 block leading-relaxed text-muted" data-id="element-285" data-mp="1du6m5t0drblk">{s.summary}</span>
                  </span>
                  <ArrowUpRightIcon className="mt-1 h-5 w-5 text-muted transition-[color,transform] duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-royal" aria-hidden="true" data-id="element-286" data-mp="2tel1w0czx932" />
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}